/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { S2SVesselSchema } from './S2SVesselSchema';
import {
    S2SVesselSchemaFromJSON,
    S2SVesselSchemaFromJSONTyped,
    S2SVesselSchemaToJSON,
} from './S2SVesselSchema';

/**
 * Schema for the S2S pair.
 * @export
 * @interface S2SPairSchema
 */
export interface S2SPairSchema {
    /**
     * 
     * @type {S2SVesselSchema}
     * @memberof S2SPairSchema
     */
    first: S2SVesselSchema;
    /**
     * 
     * @type {S2SVesselSchema}
     * @memberof S2SPairSchema
     */
    second: S2SVesselSchema;
}

/**
 * Check if a given object implements the S2SPairSchema interface.
 */
export function instanceOfS2SPairSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first" in value;
    isInstance = isInstance && "second" in value;

    return isInstance;
}

export function S2SPairSchemaFromJSON(json: any): S2SPairSchema {
    return S2SPairSchemaFromJSONTyped(json, false);
}

export function S2SPairSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2SPairSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first': S2SVesselSchemaFromJSON(json['first']),
        'second': S2SVesselSchemaFromJSON(json['second']),
    };
}

export function S2SPairSchemaToJSON(value?: S2SPairSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first': S2SVesselSchemaToJSON(value.first),
        'second': S2SVesselSchemaToJSON(value.second),
    };
}

